export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Processos',
        children: [
          {
            title: 'Home',
            route: 'home',
            icon: 'HomeIcon',
          },
        ]
      },
    ],
  },
]
